import { Nyukyokeiyaku } from "~/api/data/Nyukyokeiyaku";
/* 部屋選択コンポーネントの表示で使用するViewModel */
export class RoomSelectViewModel {
    constructor(model) {
        this.model = model;
    }
    model = new Nyukyokeiyaku();
    /** 入居状況 */
    get jokyoKb() {
        return this.model.jokyoKb;
    }
    /** 物件名 */
    get bukkenName() {
        return this.model.bukkenName;
    }
    /** 号室 */
    get roomNumber() {
        return this.model.roomNumber;
    }
    /** 物件 + 号室 */
    get bukkenNameWithRoom() {
        return this.model.bukkenNameWithRoom;
    }
    /** 住所 */
    get adress() {
        return this.model.address;
    }
    /** 入居者 */
    get nyukyosha() {
        return this.model.nyukyosha;
    }
    /** ルーム種別 */
    get roomSb() {
        return this.model.roomSb;
    }
}
